module.exports = __webpack_public_path__ + "img/miriam.60c74eb2.jpeg";